export function getImageSize(fullSize, displaySize) {
    if (!displaySize) {
        return fullSize;
    }
    else if ("width" in displaySize && "height" in displaySize) {
        return displaySize;
    }
    else if ("width" in displaySize) {
        return {
            width: displaySize.width,
            // scale the height to keep the aspect ratio
            height: (displaySize.width / fullSize.width) * fullSize.height,
        };
    }
    else {
        return {
            // scale the width to keep the aspect ratio
            width: (displaySize.height / fullSize.height) * fullSize.width,
            height: displaySize.height,
        };
    }
}
